<div class="robot-select-container">
  <app-mat-form-field appearance="standard" floatLabel="never" [hideRequiredMarker]="true">
    <!-- Robot Selection -->
    <app-mat-select
      [formControl]="robot"
      [placeholder]="placeholder"
      [matTooltip]="robots?.length > 0 ? '' : notFoundTooltip"
      (selectionChange)="onOptionSelected($event.value)"
      [compareWith]="compareCallsigns"
    >
      <app-mat-select-trigger>
        <div class="robot-option">
          <span *ngIf="robot.value?.name">{{ robot.value?.name }} ({{ robot.value?.callsign }})</span>
          <span *ngIf="!robot.value?.name">{{ robot.value?.callsign }}</span>
          <app-robot-status-dot
            *ngIf="robot.value?.callsign && includeStatus"
            [projectId]="projectId"
            [callsign]="robot.value?.callsign"
          ></app-robot-status-dot>
        </div>
      </app-mat-select-trigger>
      <app-mat-option *ngFor="let robot of robots" [value]="{ name: robot.name, callsign: robot.callsign }">
        <div class="robot-option">
          <span *ngIf="robot.name">{{ robot.name }} ({{ robot.callsign }})</span>
          <span *ngIf="!robot.name">{{ robot.callsign }}</span>
          <app-robot-status-dot
            *ngIf="includeStatus"
            [projectId]="projectId"
            [callsign]="robot.callsign"
          ></app-robot-status-dot>
        </div>
      </app-mat-option>
    </app-mat-select>

    <app-mat-error *ngIf="robot?.errors?.['required']">Required</app-mat-error>
    <app-mat-hint *ngIf="!isRobotSelected && hint">{{ hint }}</app-mat-hint>
  </app-mat-form-field>
</div>
